import React, {useEffect, useState} from 'react';
import {Modal, Icon, Table, Checkbox, Dropdown} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {useDispatch, useSelector} from 'react-redux';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {Link} from 'react-router-dom';

const {
  fecthCombosList,
  addComboToModel,
  deleteComboFromModel,
  fetchVehiclesModelsList,
} = Actions;

const KatashikiesCombosModal = ({katashikiData}) => {
  const permissions = useSelector((state) => state.session.permissions);
  const [modalOpened, setModalOpened] = useState(false);
  const loading = useSelector((state) => state.combos.loading);
  const combosList = useSelector((state) => state.combos.list);
  const [selectedCombo, setSelectedCombo] = useState('');
  const [katashikiesDataState, setKatashikiesDataState] = useState(katashikiData);
  const addComboToModelResult = useSelector((state) => state.addComboToModel);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fecthCombosList());
  }, []);

  const getChangeStatePermissions = () => {
    if (hasAccessPermission(permissions, resources.CombosManagement, scopes.Edit)) {
      return true;
    }
    return false;
  };
  
  const openKatashikiesCombosModal = (e) => {
    e.preventDefault();
    setModalOpened(true);
  };

  const closeKatashikiesCombosModal = (e) => {
    e.preventDefault();
    dispatch(fetchVehiclesModelsList(true));
    setModalOpened(false);
  };

  const getCombosDropdownOptions = () => {
    return combosList.filter((x) => x.status === 'A').map((combo) => {
      return {
        'key': combo.code,
        'text': combo.code,
        'value': combo.code,
      };
    });
  };

  const handleOnChangeCombo = (e, input) => {
    e.preventDefault();
    setSelectedCombo(input.value);
  };

  useEffect(() => {
    if (addComboToModelResult.result) {
      addComboToModelResult.action === 'ADD' ?
        setKatashikiesDataState({...katashikiesDataState,
          'comboArray':
            [...katashikiesDataState.comboArray, combosList.find((x) => x.code === addComboToModelResult.combo)]}) :
        setKatashikiesDataState({...katashikiesDataState,
          'comboArray': katashikiesDataState.comboArray.filter((x) => x.code !== addComboToModelResult.combo)});
    }
  }, [addComboToModelResult]);

  const handleAddComboToModel = (e) => {
    e.preventDefault();
    dispatch(addComboToModel(katashikiesDataState.suffix, katashikiesDataState.masterCode, selectedCombo));
  };

  const handleDeleteComboToModel = (e, combo) => {
    e.preventDefault();
    dispatch(deleteComboFromModel(katashikiesDataState.suffix, katashikiesDataState.masterCode, combo));
  };

  return (
    <Modal
      trigger={<Icon name='eye' size='big' color={'red'} link />}
      open={modalOpened}
      onOpen={(e) => openKatashikiesCombosModal(e)}
      onClose={(e) => closeKatashikiesCombosModal(e)}
      closeOnEscape={true}
      closeOnDimmerClick={true}
      size='large'
      header={
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>Combos asignados</h2>
          <Icon className='download' name='close' style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => closeKatashikiesCombosModal(e)} />
        </div>
      }
      content={
        <div className='content'>
          {getChangeStatePermissions() ?
            <div className='flex middle'>
              <div className="ui labeled input">
                <div className="ui label label">Combos</div>
                <Dropdown search selection labeled className='labeled-dropdown' loading={loading} value={selectedCombo}
                  options={getCombosDropdownOptions()} onChange={(e, input) => handleOnChangeCombo(e, input)} />
              </div>
              <Icon name='add-circle' size='big' color='green' link
                onClick={(e) => handleAddComboToModel(e)} />
            </div> : ''
          }
          <Table striped compact className='dashboard-table'>
            <Table.Header className='orders-table-header'>
              <Table.Row>
                <Table.HeaderCell width={4}>Código</Table.HeaderCell>
                <Table.HeaderCell width={8}>Descripción</Table.HeaderCell>
                <Table.HeaderCell width={3}>Estado</Table.HeaderCell>
                {getChangeStatePermissions() ?
                  <Table.HeaderCell width={1}></Table.HeaderCell> : ''}
              </Table.Row>
            </Table.Header>
            <Table.Body style={{'overflowY': 'overlay'}}>
              {katashikiesDataState.comboArray ?
                katashikiesDataState.comboArray.map((combo, index) => {
                  return <Table.Row key={index}>
                    <Table.Cell width={4}><Link to={`/combos/editar/${combo.code}`}>{combo.code}</Link></Table.Cell>
                    <Table.Cell width={8}>{combo.description}</Table.Cell>
                    <Table.Cell width={3}>
                      <Checkbox toggle checked={combo.status === 'A' ? true : false} className='green' disabled />
                    </Table.Cell>
                    {getChangeStatePermissions() ?
                      <Table.Cell width={1}><Icon name='trash' size='big' color='red' link
                        onClick={(e) => handleDeleteComboToModel(e, combo.code)} /></Table.Cell> : ''
                    }
                  </Table.Row>;
                }) : ''
              }
            </Table.Body>
          </Table>
        </div>
      }
    />
  );
};

export default KatashikiesCombosModal;
